import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { EnteDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class EnteApiClient extends BaseCRUDApiClient<EnteDto> {
  baseUrl = this.config.apiEndpoint + '/ente';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
